import { render, staticRenderFns } from "./BusinessPhoto.vue?vue&type=template&id=54b6749e&scoped=true"
import script from "./BusinessPhoto.vue?vue&type=script&lang=js"
export * from "./BusinessPhoto.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54b6749e",
  null
  
)

export default component.exports